module.exports = __webpack_public_path__ + "static/media/AgremmentAprovado.c09a45fc.svg";